import styled from 'styled-components';

export const StyledCreateCoursePage = styled.div`
  /* Code Here */
`;